module.exports = __webpack_public_path__ + "img/voz-audio-btn.24b938de.png";